import React from 'react'
import { Button, Empty, Form, Icon, Input, Modal, Popconfirm, Select, Spin, Switch, Table, Tooltip } from 'antd'
import moment from 'moment'
import commissions from '@services/commissions'
import mentors from '@services/mentors'
import { toLiteralMonth } from '@pages/Clients/Agent/Commissions/utils'
import { inject, observer } from 'mobx-react'
import OneTimeMentorCommission from '@pages/Clients/Agent/Commissions/CreateNewCommission/OneTimeMentorCommission'
import SendFinanceSms from '@components/Popup/SendFinanceSms'
import { alertPopup } from '@utils/popup'
import { literalMonth, downloadBlobFile, dateForApi } from '@utils/index'
import {
    flex,
    input_element,
    input_row,
    hRef,
    loader_container,
    main_container,
    none,
    right_col,
    select,
    selectProduct,
    select_row,
    sumContent,
    switchRow,
    tableClass,
    unsetMargin
} from '@pages/AgentCommissions/Reports/style.scss'

@inject(({ popupStore }) => ({ popupStore }))
@observer
class MentorCommissions extends React.Component {
    constructor(props) {
        super(props)
        const currentDate = new Date()
        const currentYear = currentDate.getFullYear()
        const currentMonth = currentDate.getMonth() + 1
        const months = new Array(12).fill(null).map((_, index) => index + 1)
        const yearRange = Array.from({ length: currentYear - 2016 }, (_, index) => {
            const year = 2017 + index
            return { year, months: year === currentYear ? months.filter(month => month <= currentMonth) : months }
        })
        ;(this.state = {
            loadingCommissions: false,
            loadingApprove: false,
            loadingDelete: null,
            loadingFile: false,
            commissions: [],
            page: 1,
            perPage: 100,
            total: 0,
            yearRange,
            rangeActive: false,
            selectedYear: 'בחרו שנה',
            selectedMonth: 'בחרו חודש',
            selectedYearEnd: 'בחרו שנה',
            selectedMonthEnd: 'בחרו חודש',
            rangeMonthOptions: [],
            rangeMonthOptionsEnd: [],
            mentor_search: '',
            client_search: '',
            agent_search: '',
            mentors: []
        }),
            (this.dynamicColumns = [])
    }

    componentDidMount() {
        this.getCommissions()
        this.fetchMentorsForPeriod()
    }

    fetchMentorsForPeriod = () => {
        const { selectedYear, selectedMonth } = this.state
        if (typeof selectedYear !== 'number') {
            mentors.getAllMentors({}).then(({ data }) => this.setState({ mentors: data }))
            return
        }

        const payload: any = { year: selectedYear }
        if (typeof selectedMonth === 'number') payload.month = selectedMonth
        mentors.getMentorsForPeriod(payload).then(({ data }) => this.setState({ mentors: data }))
    }

    getCommissions = () => {
        const {
            page,
            perPage,
            mentor_search,
            client_search,
            agent_search,
            rangeActive,
            selectedYear,
            selectedMonth,
            selectedYearEnd,
            selectedMonthEnd
        } = this.state

        const report_date = dateForApi(selectedYear, selectedMonth)
        const date_ranges = {
            start: { year: selectedYear, month: selectedMonth },
            end: { year: selectedYearEnd, month: selectedMonthEnd }
        }

        this.setState({ loadingCommissions: true }, () => {
            commissions
                .getMentorCommissionsByMonth({
                    report_date,
                    page,
                    perPage,
                    mentor_search,
                    client_search,
                    agent_search,
                    rangeActive,
                    date_ranges
                })
                .then(res => {
                    const { data, page, perPage, total } = res.data
                    // this.setDynamicColumns(data[0])
                    this.setState({ commissions: data, page, perPage, total })
                })
                .catch(error => {
                    console.error('error', error)
                    alertPopup({ type: 'error', title: 'אירעה שגיאה', body: '' })
                })
                .finally(() => this.setState({ loadingCommissions: false }))
        })
    }

    // downloads the excel of the current table. sends the same filters as getCommissions,
    // so the file matches what is on screen rather than the whole month.
    onLoadExcel = () => {
        const {
            loadingFile,
            mentor_search,
            client_search,
            agent_search,
            rangeActive,
            selectedYear,
            selectedMonth,
            selectedYearEnd,
            selectedMonthEnd
        } = this.state
        if (loadingFile) return

        const report_date = dateForApi(selectedYear, selectedMonth)
        const date_ranges = {
            start: { year: selectedYear, month: selectedMonth },
            end: { year: selectedYearEnd, month: selectedMonthEnd }
        }
        const fileYear = typeof selectedYear === 'number' ? selectedYear : new Date().getFullYear()
        const fileMonth = typeof selectedMonth === 'number' ? selectedMonth : ''

        this.setState({ loadingFile: true }, () => {
            commissions
                .exportMentorCommissions({ report_date, mentor_search, client_search, agent_search, rangeActive, date_ranges })
                .then(res => {
                    const monthLabel = fileMonth ? literalMonth[fileMonth as keyof typeof literalMonth] || fileMonth : ''
                    downloadBlobFile(res, monthLabel ? `עמלות מנטורים - ${monthLabel} ${fileYear}.xlsx` : `עמלות מנטורים ${fileYear}.xlsx`)
                })
                .catch(error => {
                    console.error('export error', error)
                    alertPopup({ type: 'error', title: 'שגיאת הורדת קובץ', body: '' })
                })
                .finally(() => this.setState({ loadingFile: false }))
        })
    }


    // setDynamicColumns = (obj) => {
    //     let fields = Object.keys(obj || {})

    //     fields = fields.map((field) => {
    //         return (
    //             {
    //                 title: field,
    //                 key: field,
    //                 align: 'right',
    //                 render: (record) => {
    //                     return <span>{record[field]}</span>
    //                 }
    //             }
    //         )
    //     })

    //     this.dynamicColumns = fields
    //     this.forceUpdate()
    // }

    paginate = ({ page, perPage }) => {
        this.setState({ page, perPage }, () => this.getCommissions())
    }

    handleYearSelect = selectedYear => {
        const selected = this.state.yearRange.find(item => item.year == selectedYear)
        this.setState(
            {
                page: 1,
                selectedYear,
                rangeMonthOptions: selected ? selected.months : [],
                selectedMonth: 'בחרו חודש',
                selectedYearEnd: 'בחרו שנה',
                rangeMonthOptionsEnd: [],
                selectedMonthEnd: 'בחרו חודש',
                mentor_search: ''
            },
            () => this.fetchMentorsForPeriod()
        )
    }

    handleYearSelectEnd = selectedYearEnd => {
        const selected = this.state.yearRange.find(item => item.year == selectedYearEnd)
        this.setState({
            page: 1,
            selectedYearEnd,
            rangeMonthOptionsEnd: selected ? selected.months : [],
            selectedMonthEnd: 'בחרו חודש'
        })
    }

    handleMonthSelect = (selectedMonth, key) => {
        if (key === 'selectedMonth') {
            this.setState(
                {
                    page: 1,
                    selectedMonth,
                    selectedYearEnd: 'בחרו שנה',
                    rangeMonthOptionsEnd: [],
                    selectedMonthEnd: 'בחרו חודש',
                    mentor_search: ''
                },
                () => this.fetchMentorsForPeriod()
            )
            return
        }

        this.setState({ page: 1, [key]: selectedMonth })
    }

    onNumberInput = ({ target: { value } }, key) => {
        this.setState({ page: 1, [key]: value.replace(/[^0-9]/g, '') })
    }

    onTextInput = ({ target: { value } }, key) => {
        this.setState({ page: 1, [key]: value })
    }

    onRangeSwitch = rangeActive => this.setState({ rangeActive, page: 1 })

    onSearch = event => {
        event.preventDefault()
        const {
            loadingCommissions,
            rangeActive,
            selectedYear,
            selectedMonth,
            selectedYearEnd,
            selectedMonthEnd
        } = this.state
        const rangeIncomplete =
            rangeActive &&
            (typeof selectedYear === 'string' ||
                typeof selectedMonth === 'string' ||
                typeof selectedYearEnd === 'string' ||
                typeof selectedMonthEnd === 'string')
        if (loadingCommissions || rangeIncomplete) return

        this.setState({ page: 1 }, () => this.getCommissions())
    }

    resetSearchData = () => {
        // back to no filters at all, then reload
        this.setState(
            {
                page: 1,
                rangeActive: false,
                selectedYear: 'בחרו שנה',
                selectedMonth: 'בחרו חודש',
                selectedYearEnd: 'בחרו שנה',
                selectedMonthEnd: 'בחרו חודש',
                rangeMonthOptions: [],
                rangeMonthOptionsEnd: [],
                mentor_search: '',
                client_search: '',
                agent_search: ''
            },
            () => {
                this.getCommissions()
                this.fetchMentorsForPeriod()
            }
        )
    }

    deleteCommission = commission_id => {
        this.setState({ loadingDelete: commission_id }, () => {
            commissions
                .deleteMentorCommission({ commission_id })
                .then(() => {
                    this.getCommissions()
                })
                .catch(error => {
                    console.log('error. delete mentor-commission', error)
                    alertPopup({ type: 'error', title: 'אירעה שגיאה', body: '' })
                })
                .finally(() => this.setState({ loadingDelete: null }))
        })
    }

    approve = () => {
        // approves the month currently selected in the visible selects
        const { selectedYear, selectedMonth } = this.state
        const now = new Date()
        const month = typeof selectedMonth === 'number' ? selectedMonth : now.getMonth() + 1
        const year = typeof selectedYear === 'number' ? selectedYear - 2000 : now.getFullYear() - 2000

        this.setState({ loadingApprove: true }, () => {
            commissions
                .approveMentorCommissions({ year, month })
                .then(() => {
                    alertPopup({ type: 'success', title: 'אישור העמלות בוצע בהצלחה', body: '' })
                })
                .catch(error => {
                    console.log('approve error', error)
                    alertPopup({ type: 'error', title: 'אירעה שגיאה', body: '' })
                })
                .finally(() => this.setState({ loadingApprove: false }))
        })
    }

    // statuses = (status) => {
    //     let obj = {
    //         ACTIVE: { text: 'פעיל', color: 'green' },
    //         CANCELED: { text: 'בוטל', color: 'red' }
    //     }

    //     return obj[status] || { text: status, color: '' }
    // }

    balances = balance => {
        let obj = {
            CREDIT: { text: 'זכות', color: 'green' },
            DEBT: { text: 'חיוב', color: 'red' }
        }

        return obj[balance] || { text: balance, color: '' }
    }

    balances2 = balance => {
        return balance == 1
            ? { text: 'זכות', color: 'green' }
            : balance == -1
            ? { text: 'חיוב', color: 'red' }
            : { text: balance, color: '' }
    }

    // opens in a new tab (plain anchor, not NavLink/window.open) so ctrl/middle-click still work
    renderPersonLink = (path, id, name) => {
        if (!id) return <div>{'-'}</div>

        return (
            <span>
                {name ? `${name} - ` : ''}
                <a href={`${path}/${id}`} target="_blank" rel="noopener noreferrer" className={hRef}>
                    {id}
                </a>
            </span>
        )
    }

    paymentTypes = type => {
        let obj = {
            YEARLY: 'שנתית',
            MONTHLY: 'חודשית',
            ONE_TIME: 'חד-פעמית',
            GENERAL_ONE_TIME: 'כללית, חד-פעמית'
        }

        return obj[type] || type
    }

    infoModal = text => Modal.info({ title: text, okType: 'primary' })

    payedDiv = i => <Icon type={i ? 'check' : 'close'} style={{ color: i ? 'green' : 'red' }} />

    renderSignedAmount = (rawValue, sign = 1) => {
        const isEmpty =
            rawValue === null || rawValue === undefined || (typeof rawValue === 'string' && rawValue.trim() === '')
        const value = Number(rawValue)

        if (isEmpty || !Number.isFinite(value)) {
            return <div className={sumContent}>{rawValue}</div>
        }

        const signedValue = value * sign
        let formatted = signedValue.toFixed(2)
        if (formatted.endsWith('.00')) formatted = parseFloat(formatted).toString()
        const parts = formatted.split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

        return (
            <div className={sumContent} style={{ color: signedValue < 0 ? 'red' : 'green' }}>
                {parts.join('.')}
            </div>
        )
    }

    createCommissionPopup = () => {
        this.props.popupStore.togglePopup('oneTimeMentorCommission')
    }

    columns2 = [
        {
            // a mentor commission has no `payed` flag — it counts as paid once it has been
            // approved into a monthly report, which is what the `report` field holds
            title: 'שולם',
            key: 'payed',
            align: 'center',
            width: 50,
            render: record => this.payedDiv(record.report)
        },
        {
            // the server sends this as "month/year", already the month the row was reported in
            title: 'תאריך דו"ח',
            key: 'mentor_paid_at',
            align: 'center',
            width: 40,
            render: record => <span>{record.mentor_paid_at || '-'}</span>
        },
        {
            title: 'תאריך רכישה',
            key: 'date',
            align: 'center',
            width: 40,
            render: record => {
                const date = moment(record.date)
                return <span>{record.date && date.isValid() ? date.format('DD/MM/YY') : '-'}</span>
            }
        },
        {
            title: 'סוג עמלה',
            key: 'payment_type',
            align: 'center',
            width: 40,
            render: record => <span>{this.paymentTypes(record.payment_type)}</span>
        },
        {
            title: 'לקוח',
            key: 'client_name',
            align: 'center',
            width: 120,
            render: record => this.renderPersonLink('/clients', record.client_id, record.client_full_name)
        },
        {
            title: 'סוכן',
            key: 'agent_name',
            align: 'center',
            width: 120,
            render: record => this.renderPersonLink('/agents', record.agent_id, record.provided_by_full_name)
        },
        {
            title: 'מנטור',
            key: 'mentor_name',
            align: 'center',
            width: 40,
            render: record => <span>{record.mentor_name}</span>
        },
        {
            title: 'סכום',
            key: 'amount',
            align: 'center',
            width: 40,
            render: record => this.renderSignedAmount(record.amount)
        },
        {
            title: 'חודשים לחיוב',
            key: 'months_to_charge',
            align: 'center',
            width: 40,
            render: record => <span>{record.months_to_charge}</span>
        },
        {
            title: 'זכות/חיוב',
            key: 'quantity',
            align: 'center',
            width: 40,
            render: record => (
                <span style={{ color: this.balances2(record.quantity).color }}>
                    {this.balances2(record.quantity).text}
                </span>
            )
        },
        {
            title: 'שנתי',
            key: 'yearly_amount',
            align: 'center',
            width: 40,
            render: record => {
                // yearly_amount comes unsigned from the server, so the sign is applied here.
                // one-time types are blank, so GENERAL_ONE_TIME never reaches this line.
                return ['ONE_TIME', 'GENERAL_ONE_TIME'].includes(record.payment_type)
                    ? ''
                    : this.renderSignedAmount(record.yearly_amount, Number(record.quantity) === -1 ? -1 : 1)
            }
        },
        {
            title: 'עמלת מנטור',
            key: 'mentor_commission',
            align: 'center',
            width: 40,
            // the value arrives already signed from the server: negative for חיוב
            // that is not GENERAL_ONE_TIME. do not flip it again here.
            render: record => this.renderSignedAmount(record.mentor_commission)
        },
        {
            title: 'הערה',
            key: 'mentor_commission_comment',
            align: 'center',
            width: 40,
            render: record => (
                <a
                    href={'#'}
                    className={`${hRef} ${record.mentor_commission_comment ? '' : none}`}
                    onClick={() => this.infoModal(record.mentor_commission_comment)}
                >
                    {'להערה'}
                </a>
            )
        },
        {
            title: '',
            key: 'delete',
            align: 'center',
            width: 40,
            render: record => {
                if (record.payment_type === 'GENERAL_ONE_TIME') {
                    return (
                        <Popconfirm
                            title={'האם למחוק את העמלה?'}
                            okText={'כן'}
                            cancelText={'לא'}
                            onConfirm={() => this.deleteCommission(record.id)}
                        >
                            {this.state.loadingDelete === record.id ? (
                                <Spin />
                            ) : (
                                <Icon type="delete" style={{ color: 'red', cursor: 'pointer' }} />
                            )}
                        </Popconfirm>
                    )
                }

                return <Icon type="delete" style={{ color: '#bfbfbf', cursor: 'default' }} />
            }
        }
    ]

    // columns = [
    //     {
    //         title: 'נוצר בתאריך',
    //         key: 'created_at',
    //         align: 'right',
    //         render : (record) => <span>{moment(record.created_at).format('DD/MM/YYYY hh:mm')}</span>
    //     },
    //     {
    //         title: 'עודכן בתאריך',
    //         key: 'updated_at',
    //         align: 'right',
    //         render : (record) => <span>{moment(record.updated_at).format('DD/MM/YYYY hh:mm')}</span>
    //     },
    //     {
    //         title: 'שם המנטור',
    //         key: 'mentor_name',
    //         align: 'right',
    //         render : (record) => <span>{record.mentor_name}</span>
    //     },
    //     {
    //         title: 'שם הסוכן',
    //         key: 'agent_name',
    //         align: 'right',
    //         render : (record) => <span>{record.provided_by_full_name}</span> // <span>{`${record.agent_first_name} ${record.agent_last_name}`}</span>
    //     },
    //     {
    //         title: 'שם המינוי',
    //         key: 'sub_name',
    //         align: 'right',
    //         render : (record) => <span>{record.subscription_name}</span>
    //     },
    //     {
    //         title: 'מחיר',
    //         key: 'amount',
    //         align: 'right',
    //         render : (record) => <span>{record.amount}</span>
    //     },
    //     {
    //         title: 'זכות/חיוב',
    //         key: 'balance',
    //         align: 'right',
    //         render : (record) => <span style={{ color: this.balances(record.balance).color }}>{this.balances(record.balance).text}</span>
    //     },
    //     // {
    //     //     title: 'סטטוס',
    //     //     key: 'status',
    //     //     align: 'right',
    //     //     render : (record) => <span style={{ color: this.statuses(record.status).color }}>{this.statuses(record.status).text}</span>
    //     // },
    //     {
    //         title: 'חודשים',
    //         key: 'months',
    //         align: 'right',
    //         render : (record) => {
    //             let months =
    //             record.balance === 'CREDIT' ?
    //                 (record.payment_type === 'ONE_TIME' ? 1 : 12) :
    //                 record.months_to_charge
    //             return <span>{months}</span>
    //         }
    //     },
    //     {
    //         title: 'חיוב/זיכוי מחושב',
    //         key: 'calculated',
    //         align: 'right',
    //         render : (record) => {
    //             let months =
    //             record.balance === 'CREDIT' ?
    //                 (record.payment_type === 'ONE_TIME' ? 1 : 12) :
    //                 record.months_to_charge

    //             return (
    //                 <Tooltip
    //                     title={
    //                         <span>
    //                             <span>{months}</span>
    //                             <span>{" X "}</span>
    //                             <span>{record.amount}</span>
    //                             <span>{" X "}</span>
    //                             <span>{record.percent}</span>
    //                         </span>
    //                     }
    //                 >
    //                     <span>{(months * record.amount * record.percent).toFixed(2)}</span>
    //                 </Tooltip>
    //             )

    //         }
    //     },
    //     {
    //         title: 'שנה',
    //         key: 'year',
    //         align: 'right',
    //         render : (record) => <span>{record.year + 2000}</span>
    //     },
    //     {
    //         title: 'חודש',
    //         key: 'month',
    //         align: 'right',
    //         render : (record) => <span>{toLiteralMonth(record.month)}</span>
    //     }
    // ]

    render() {
        const {
            commissions,
            page,
            perPage,
            total,
            loadingCommissions,
            loadingApprove,
            loadingFile,
            yearRange,
            rangeActive,
            selectedYear,
            selectedMonth,
            selectedYearEnd,
            selectedMonthEnd,
            rangeMonthOptions,
            rangeMonthOptionsEnd,
            mentor_search,
            client_search,
            agent_search,
            mentors: mentorList
        } = this.state
        const rangeIncomplete =
            rangeActive &&
            (typeof selectedYear === 'string' ||
                typeof selectedMonth === 'string' ||
                typeof selectedYearEnd === 'string' ||
                typeof selectedMonthEnd === 'string')

        return (
            <>
                <div style={{ ...style.column }}>
                    <div className={main_container}>
                        <div className={right_col}>
                            <div className={select_row}>
                                <div className={switchRow}>
                                    <div style={{ marginLeft: '15px' }}>טווח תאריכים</div>
                                    <Switch checked={rangeActive} onClick={this.onRangeSwitch} />
                                </div>
                                {/* year and month are always visible, like the עמלות panel.
                                    only the end-of-range pair is conditional on the switch */}
                                <Select className={select} value={selectedYear} onChange={this.handleYearSelect}>
                                    {yearRange.map(data => (
                                        <Select.Option key={data.year} value={data.year}>
                                            {data.year}
                                        </Select.Option>
                                    ))}
                                </Select>
                                <Select
                                    className={select}
                                    disabled={!!!rangeMonthOptions.length}
                                    value={literalMonth[selectedMonth] || selectedMonth}
                                    onChange={value => this.handleMonthSelect(value, 'selectedMonth')}
                                >
                                    {rangeMonthOptions.map(rangeMonth => (
                                        <Select.Option key={rangeMonth} value={rangeMonth}>
                                            {literalMonth[rangeMonth]}
                                        </Select.Option>
                                    ))}
                                </Select>
                                {rangeActive ? (
                                    <>
                                        <Select
                                            className={select}
                                            value={selectedYearEnd}
                                            disabled={typeof selectedMonth === 'string'}
                                            onChange={this.handleYearSelectEnd}
                                        >
                                            {yearRange
                                                .filter(item => item.year >= selectedYear)
                                                .map(data => (
                                                    <Select.Option key={data.year} value={data.year}>
                                                        {data.year}
                                                    </Select.Option>
                                                ))}
                                        </Select>
                                        <Select
                                            className={select}
                                            disabled={typeof selectedYearEnd === 'string'}
                                            value={literalMonth[selectedMonthEnd] || selectedMonthEnd}
                                            onChange={value => this.handleMonthSelect(value, 'selectedMonthEnd')}
                                        >
                                            {rangeMonthOptionsEnd
                                                .filter(rangeMonth =>
                                                    selectedYearEnd === selectedYear
                                                        ? rangeMonth >= selectedMonth
                                                        : rangeMonth
                                                )
                                                .map(rangeMonth => (
                                                    <Select.Option key={rangeMonth} value={rangeMonth}>
                                                        {literalMonth[rangeMonth]}
                                                    </Select.Option>
                                                ))}
                                        </Select>
                                    </>
                                ) : null}
                            </div>
                            <Form className={input_row} onSubmit={this.onSearch}>
                                <Select
                                    placeholder={'שם מנטור'}
                                    className={selectProduct}
                                    style={{ width: 200, marginLeft: 10 }}
                                    allowClear
                                    notFoundContent={'אין מנטורים בתקופה זו'}
                                    value={mentor_search || undefined}
                                    onChange={value => this.setState({ page: 1, mentor_search: value || '' })}
                                >
                                    {mentorList.map((mentor: any) => (
                                        <Select.Option key={mentor.id} value={String(mentor.id)}>
                                            {mentor.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                                <Input
                                    placeholder={'מזהה לקוח'}
                                    className={input_element}
                                    value={client_search}
                                    onInput={event => this.onTextInput(event, 'client_search')}
                                />
                                <Input
                                    placeholder={'מזהה סוכן'}
                                    className={input_element}
                                    value={agent_search}
                                    onInput={event => this.onTextInput(event, 'agent_search')}
                                />
                                <Button htmlType="submit" disabled={loadingCommissions || rangeIncomplete}>
                                    <Icon type={'search'} />
                                    {'חיפוש'}
                                </Button>
                                <Button
                                    onClick={this.resetSearchData}
                                    className={unsetMargin}
                                    disabled={loadingCommissions}
                                >
                                    {'איפוס'}
                                    <Icon type={'sync'} />
                                </Button>
                            </Form>
                        </div>
                        <div className={flex}>
                            <Button onClick={this.createCommissionPopup}>
                                <Icon type={'plus-circle'} />
                                {'יצירת חיוב/זיכוי'}
                            </Button>
                            <Button onClick={this.onLoadExcel}>
                                <Icon type={loadingFile ? 'loading' : 'download'} />
                                {'הורדת קובץ'}
                            </Button>

                        </div>
                    </div>

                    <Table
                        // columns={this.dynamicColumns}
                        className={`center-table mentorCommissionsTable ${
                            !loadingCommissions && commissions.length ? '' : none
                        } ${tableClass}`}
                        rowKey="id"
                        columns={this.columns2}
                        dataSource={commissions}
                        // scroll={{ x: 2250 }}
                        bordered={true}
                        pagination={{
                            total,
                            pageSize: perPage,
                            current: page,
                            hideOnSinglePage: true,
                            onChange: nextPage => this.paginate({ page: nextPage, perPage })
                        }}
                    />
                    <div className={`${loader_container} ${loadingCommissions ? '' : none}`}>
                        <Spin size="large" />
                    </div>
                    {!loadingCommissions && !commissions.length ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /> : null}
                </div>

                {this.props.popupStore.popupType === 'oneTimeMentorCommission' ? (
                    <OneTimeMentorCommission getCommissions={this.getCommissions} />
                ) : (
                    ''
                )}

            </>
        )
    }
}

const style = {
    column: { display: 'flex', flexDirection: 'column' },
    flex: { display: 'flex' }
}

export default MentorCommissions
